import { Component, inject, isDevMode, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { TranslateService } from '@dental-ui/shared/i18n';
import { autobarDocumentTitle } from '@dental-ui/shared/consts';

// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  HeaderComponent,
  FooterComponent,
  ContactDrawerComponent,
} from '@dental-ui/landing';

@Component({
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    ContactDrawerComponent,
  ],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private title = inject(Title);
  private translateService = inject(TranslateService);

  contactOpen = false;

  ngOnInit() {
    this.translateService.loadLibrary('landing');
    this.title.setTitle(autobarDocumentTitle(null, isDevMode()));
  }

  onActivate(componentRef: unknown) {
    const comp = componentRef as { contactClick?: { subscribe: (fn: () => void) => void }; trialClick?: { subscribe: (fn: () => void) => void } };
    if (comp.contactClick) {
      comp.contactClick.subscribe(() => {
        this.contactOpen = true;
      });
    }
    if (comp.trialClick) {
      comp.trialClick.subscribe(() => {
        this.redirectToRegister();
      });
    }
  }

  redirectToLogin() {
    window.open(`${environment.appUrl}/#/login`, '_blank', 'noopener,noreferrer');
  }

  redirectToRegister() {
    window.open(`${environment.appUrl}/#/register`, '_blank', 'noopener,noreferrer');
  }
}
